import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.css';
import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './components/ToastProvider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppRouter } from './AppRouter';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ToastProvider>
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </ToastProvider>
  </React.StrictMode>
);

reportWebVitals();
